export function combineURLs(baseURL: string, relativeURL?: string) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

export function isURLMatchProtocols(urlString: string, protocols: string | string[]) {
  try {
    const protocolArray = Array.isArray(protocols) ? protocols : [protocols];
    const url = new URL(urlString);
    const urlProtocol = url.protocol.replace(':', '');
    return protocolArray.some(protocol => protocol.toLocaleLowerCase() === urlProtocol.toLocaleLowerCase());
  } catch {
    return false;
  }
}

export function isWebpageUrl(url: string) {
  return isURLMatchProtocols(url, ['http', 'https']);
}
